import React from 'react';

const Loader = () => {
    return (
        <div className="main_bg">
            <div className="main_bg2">
                <div className="flex items-center justify-center h-screen bg-[#0b11209f] text-white">
                <div className="container">
                    <div className="item item-1"></div>
                    <div className="item item-2"></div>
                    <div className="item item-3"></div>
                    <div className="item item-4"></div>
                </div>
                <div className="loader mt-40">
                    <div style={{ fontFamily: " 'Dancing Script', cursive" }} className="scanner text-white">
                        <h1>Loading...</h1>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};

export default Loader;